/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiAggregationsDetectionResultAggregationsInner } from './InternalApiAggregationsDetectionResultAggregationsInner';
import {
    InternalApiAggregationsDetectionResultAggregationsInnerFromJSON,
    InternalApiAggregationsDetectionResultAggregationsInnerFromJSONTyped,
    InternalApiAggregationsDetectionResultAggregationsInnerToJSON,
    InternalApiAggregationsDetectionResultAggregationsInnerToJSONTyped,
} from './InternalApiAggregationsDetectionResultAggregationsInner';

/**
 * Response for aggregations detection
 * @export
 * @interface InternalApiAggregationsDetectionResult
 */
export interface InternalApiAggregationsDetectionResult {
    /**
     * 
     * @type {Array<InternalApiAggregationsDetectionResultAggregationsInner>}
     * @memberof InternalApiAggregationsDetectionResult
     */
    aggregations: Array<InternalApiAggregationsDetectionResultAggregationsInner>;
}

/**
 * Check if a given object implements the InternalApiAggregationsDetectionResult interface.
 */
export function instanceOfInternalApiAggregationsDetectionResult(value: object): value is InternalApiAggregationsDetectionResult {
    if (!('aggregations' in value) || value['aggregations'] === undefined) return false;
    return true;
}

export function InternalApiAggregationsDetectionResultFromJSON(json: any): InternalApiAggregationsDetectionResult {
    return InternalApiAggregationsDetectionResultFromJSONTyped(json, false);
}

export function InternalApiAggregationsDetectionResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiAggregationsDetectionResult {
    if (json == null) {
        return json;
    }
    return {
        
        'aggregations': ((json['aggregations'] as Array<any>).map(InternalApiAggregationsDetectionResultAggregationsInnerFromJSON)),
    };
}

export function InternalApiAggregationsDetectionResultToJSON(json: any): InternalApiAggregationsDetectionResult {
    return InternalApiAggregationsDetectionResultToJSONTyped(json, false);
}

export function InternalApiAggregationsDetectionResultToJSONTyped(value?: InternalApiAggregationsDetectionResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'aggregations': ((value['aggregations'] as Array<any>).map(InternalApiAggregationsDetectionResultAggregationsInnerToJSON)),
    };
}

